module.exports = __webpack_public_path__ + "img/facility3.3c794eb6.png";